import {formatLocalDate} from "./adminDateFormat";
import type {StatusTone} from "../../Components/ui/StatusTag";

export type ArchivedEventDisplayFields = {
    code?: string | null;
    name?: string | null;
    nameHr?: string | null;
    nameEn?: string | null;
};

export type EventOperationalStatus = "draft" | "active" | "completed";

export type EventOperationalStatusFields = {
    arbitraryFieldsTemplateId?: number | null;
    lifecycleStatus?: string | null;
};

export const formatEventDateRange = (startDate?: string | null, endDate?: string | null) => {
    const start = formatLocalDate(startDate);
    const end = formatLocalDate(endDate);
    return start === "-" && end === "-" ? "-" : `${start} - ${end}`;
};

export const eventLifecycleStatusTone = (status?: string | null): StatusTone => {
    switch ((status ?? "").trim().toUpperCase()) {
    case "DRAFT":
        return "warning";
    case "ACTIVE":
        return "success";
    case "COMPLETED":
        return "info";
    default:
        return "neutral";
    }
};

export const eventOperationalStatusTone = (status: EventOperationalStatus): StatusTone => {
    switch (status) {
    case "active":
        return "success";
    case "completed":
        return "info";
    case "draft":
    default:
        return "warning";
    }
};

export const getEventOperationalStatus = (event: EventOperationalStatusFields): EventOperationalStatus => {
    const lifecycleStatus = (event.lifecycleStatus ?? "").trim().toUpperCase();

    if (lifecycleStatus === "DRAFT") {
        return "draft";
    }

    if (lifecycleStatus === "COMPLETED") {
        return "completed";
    }

    if (lifecycleStatus === "ACTIVE") {
        return "active";
    }

    return event.arbitraryFieldsTemplateId ? "active" : "draft";
};

export const getEventDisplayName = (event: ArchivedEventDisplayFields) => {
    const name = event.name?.trim() || event.nameHr?.trim() || event.nameEn?.trim();
    return name || event.code?.trim() || "-";
};

export const getArchivedEventDisplayName = getEventDisplayName;
